import { ModalProps } from "@/src/types/components/Modal";

const Modal = ({
  isOpen,
  onClose,
  title,
  message,
  actionButtonText,
  onAction,
  children,
}: ModalProps) => {
  return (
    <dialog
      open={isOpen}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 w-screen h-screen"
    >
      <div className="bg-white rounded-lg shadow-lg w-11/12 md:w-1/3">
        <div className="flex justify-between items-center border-b p-4">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="p-4">
          <p>{message}</p>
          {children}
        </div>
        <div className="flex justify-end border-t p-4">
          <button onClick={onClose} className="button button-primary">
            Sluiten
          </button>
          {onAction && actionButtonText && (
            <button onClick={onAction} className="button button-secondary ml-4">
              {actionButtonText}
            </button>
          )}
        </div>
      </div>
    </dialog>
  );
};

export default Modal;
